module.exports = __webpack_public_path__ + "img/alert-triangle.4dd55bfe.svg";